module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-inverse navbar-fixed-top z-depth-1 b-0 new-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-brand hidden-xs",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/logo.png")
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand visible-xs",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/logo-xs.png")
    }
  })])], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    class: {
      active: _vm.context === 'patient'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/patient"
    }
  }, [_vm._v("Patient")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.context === 'practice'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/practice"
    }
  }, [_vm._v("Practice")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.context === 'academic'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/academic"
    }
  }, [_vm._v("Academic")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "navbar-right nav-xs"
  }, [_c('router-link', {
    staticClass: "btn btn-primary navbar-btn",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary navbar-btn m-l",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Signup")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf3260a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/NavBar.vue
// module id = 676
// module chunks = 5